import React, { CSSProperties } from "react";
import { Button, Text, TextBold } from "..";
import { Container, EmptyDataImg } from "./_emptyDataSmileStyle";

type OwnProps = {
  title?: string;
  text?: string;
  children?: React.ReactNode;
  variantImage?: "file" | "people" | "tree" | "default";
  style?: CSSProperties;
  className?: string;
};

// @ts-expect-error TS(2565): Property 'defaultProps' is used before being assig... Remove this comment to see the full error message
type Props = OwnProps & typeof EmptyDataSmile.defaultProps;

function EmptyDataSmile(props: Props) {
  // @ts-expect-error TS(2339): Property 'button' does not exist on type 'Props'.
  const { title, text, button, handleClickButton, children, variantImage, ...rest } = props;
  return (
    <Container className="empty-data-smile-container" {...rest}>
      <EmptyDataImg variant={variantImage} className="empty-data-image" />
      <TextBold textAlign="center" size={20} mb={8} color="titles" className="empty-data-title">
        {title}
      </TextBold>
      <Text size={16} color="titles" textAlign="center" className="empty-data-text">
        {text}
      </Text>
      {button && handleClickButton && (
        <Button rounded variant="secondary" onClick={handleClickButton}>
          {button}
        </Button>
      )}
      {children}
    </Container>
  );
}

EmptyDataSmile.defaultProps = {
  title: "",
  text: "",
  variantImage: "default",
};

export default EmptyDataSmile;
